import React from 'react';
import PropType from 'prop-types';
import Icon from '../Icon/Icon';

export default function WorkoutOwnerHeading({ workout, when, icon }) {
  return (
    <div className="columns is-multiline is-marginless workout-owner-header">
      <div className="column is-12 is-12-mobile">
        {workout && (
        <div className="level is-mobile">
          <div className="level-left">
            <figure className="level-item image is-48x48 is-round">
              <img src={workout.userPhoto || '/images/placeholders/no-profile-image.png'} alt={workout.fullname} />
            </figure>
            <div className="level-item is-narrow">
              <div>
                <h2 className="title is-5 is-spaced-small is-spaced">{workout.fullname}</h2>
                <h3 className="subtitle is-6">{when}</h3>
              </div>
            </div>
          </div>
          {icon && <Icon className="level-right" size="24" color="#000" codePoint={icon} />}
        </div>
        )}
      </div>
    </div>
  );
}
WorkoutOwnerHeading.defaultProps = {
  icon: null,
};
WorkoutOwnerHeading.propTypes = {
  workout: PropType.object.isRequired,
  when: PropType.string.isRequired,
  icon: PropType.string,
};
